import React, { useState, useEffect } from 'react';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

const SearchBar = ({
  value, setValue, forceUpperCase = false, placeholder,
}) => (
  <div>
    <Col>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={({ target: { value: newValue } }) => setValue(
          forceUpperCase ? newValue.toUpperCase() : newValue.toLowerCase(),
        )}
      />
    </Col>
  </div>
);

const MultiSearchBar = ({
  macAddress: macAddressProp = '', pairing: pairingProp = '', email: emailProp = '', onSearch,
}) => {
  const [macAddress, setMacAddress] = useState(macAddressProp);
  const [pairing, setPairing] = useState(pairingProp);
  const [email, setEmail] = useState(emailProp);

  useEffect(() => {
    if (macAddress) {
      setPairing('');
      setEmail('');
    }
  }, [macAddress]);

  useEffect(() => {
    if (pairing) {
      setEmail('');
      setMacAddress('');
    }
    if (pairing[4] && pairing[4] !== '-') {
      setPairing(`${pairing.substring(0, 4)}-${pairing.substring(4)}`.toUpperCase());
    }
    if (pairing.length > 9) {
      setPairing(pairing.substring(0, 9));
    }
  }, [pairing]);

  useEffect(() => {
    if (email) {
      setPairing('');
      setMacAddress('');
    }
  }, [email]);

  const onButtonClick = (e) => {
    e.preventDefault();
    onSearch({ email, macAddress, pairing });
  };

  return (
    <Form onSubmit={onButtonClick}>
      <FormGroup>
        <Label>Search box</Label>
        <Container>
          <Row>

            <SearchBar
              value={macAddress}
              setValue={setMacAddress}
              placeholder="MAC Address"
              forceUpperCase
            />
            <SearchBar
              value={pairing}
              setValue={setPairing}
              placeholder="Secret Code (XXXX-XXXX)"
              forceUpperCase
            />
            <SearchBar
              value={email}
              setValue={setEmail}
              type="email"
              placeholder="user's email"
            />
            <Col>
              <Button
                type="submit"
                color="primary"
              >
                Search
              </Button>
            </Col>
          </Row>
        </Container>
      </FormGroup>
    </Form>
  );
};

export default MultiSearchBar;



// WEBPACK FOOTER //
// ./src/components/lovebox-info/multi-search-bar.js